class LogoMarquee extends HTMLElement {
  constructor() {
    super();

    return;

    this.$marquee = this.querySelector('.js-logo-marquee');
    this.$scroll = this.querySelector('.logo-marquee__scroll');
    this.$pause = this.querySelector('.logo-marquee__pause');
    this.$logos = this.querySelectorAll('.logo-marguee__item');
    this.count = this.$logos.length;
    this.paused = false;
    this.animation = this.$scroll.getAnimations()[0];
    this.setup();
    this.$pause.addEventListener('click', this.onClick.bind(this));

    this.addEventListener('focusin', function( e ){
      if( e.target !== this.$pause ){
        this.pause();
      }
    });


    this.addEventListener('focusin', function( e ){
      const logo = e.target.closest('.logo-marguee__item');

      console.log(logo);

      if (!logo) return;

      logo.scrollIntoView({
        behavior: 'smooth',
        inline: 'nearest',
        block: 'nearest'
      });         
    });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if ( !entry.isIntersecting ) {

          entry.target.classList.add('tester');
          // Optional: Stop observing after animation triggers once
          // observer.unobserve(entry.target); 
        }
      });
    }, { threshold: 0.1 }); // Triggers when 10% is visible

    this.$logos.forEach(el => observer.observe(el));

    // const self = this;
    // this.$logos.forEach( ($logo, index) => {
    //   $logo.setAttribute('rel', index);
    //   $logo.addEventListener('keyup', function( e ){
    //     if( e.key === "Tab" ){
    //       const position = $logo.getBoundingClientRect();
    //       const rel = $logo.getAttribute('rel');

    //       if( 
    //         position.x < 0 
    //         || position.x + $logo.offsetWidth > window.innerWidth
    //       ){
    //         self.setAnimationPosition( rel );          
    //       }
    //     }
    //   })
    // });
  }

  bringIntoView(logo, track, container) {
    const rect = logo.getBoundingClientRect();
    const parent = container.getBoundingClientRect();

    let shift = 0;

    if (rect.left < parent.left) {
      shift = parent.left - rect.left; // move right
    } else if (rect.right > parent.right) {
      shift = parent.right - rect.right; // move left
    }

    if (shift === 0) return;

    // Get current transform
    const style = window.getComputedStyle(track);
    const matrix = new DOMMatrix(style.transform);

    const currentX = matrix.m41;

    track.style.transform = `translateX(${currentX + shift}px)`;
  }

  setAnimationPosition( rel ) {
    const duration = this.animation.effect.getTiming().duration;
    const durationItr = duration/this.count;

    if( rel == 0 ){
      this.animation.currentTime = 0;
    }else{
      this.animation.currentTime = durationItr * parseInt(rel);      
    }
  }

  onClick() {
    if( this.paused ){
      this.play();
    }else{
      this.pause();
    }
  }

  pause() {
    this.$pause.setAttribute('aria-pressed', true);
    this.paused = true;
    this.animation.pause();
  }

  play() {
    this.$pause.setAttribute('aria-pressed', false);
    this.paused = false;
    this.animation.play();
  }

  setup() {
    let clone = document.createElement('div');
    clone.className = 'logo-marquee__scroll  js-logo-marquee-scroll-clone';
    clone.innerHTML = this.$marquee.innerHTML;
    clone.setAttribute('tabindex', -1);

    const logos = clone.querySelectorAll('.logo-marguee__item a');

    logos.forEach( logo => {
      logo.setAttribute('tabindex', -1);
    });

    this.$marquee.appendChild(clone);
  }
}

customElements.define('logo-marquee', LogoMarquee);